import ShortUrl from 'umg-ember-backend/components/record-explorer/for/short-url';

<template><ShortUrl @records={{@model}} @recordType='short-url' /></template>
